import React from 'react'
import { useTranslation } from "react-i18next";
import { Modal, ModalTitle, ModalFooter } from "@vds/modals";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { TitleLockup } from "@vds3/type-lockups";

function RemoveModalByod(props) {
  const { t } = useTranslation(["byod"]);

  return (
    <>
      {!!props.deviceId && (
        <RemoveDeviceModalByod
          hideCloseButton={true}
          disableOutsideClick={false}
          onOpenedChange={(e) => {
            if (!e) {
              props.close(null)
            }
          }}
          opened={!!props.showModal}
        >
          <ModalTitle>
            <TitleLockup
              data={{
                title: {
                  bold: true,
                  size: "titleLarge",
                  children: t("byod.byod-collection.removeModalHeading", { ns: "byod" }),
                }
              }}
            />
          </ModalTitle>
          <ModalFooter
            children={
              <ButtonGroup>
                <Button ClassName="customerButton"
                  width="100%"
                  use="primary"
                  onClick={() => props.removeByodDevice(props.deviceId)}
                >
                  Remove
                </Button>
                <Button ClassName="customerButton"
                  width="100%"
                  use="secondary"
                  onClick={() => props.close(null)}
                  data-track={`Device | ${props.deviceId} | Cancel`}
                  
                >
                  Cancel
                </Button>
              </ButtonGroup>
            }
          />
        </RemoveDeviceModalByod>
      )}
    </>
  );
}

const RemoveDeviceModalByod = styled(Modal)`

[data-testid="modal-header"]{
  padding-right : 0px;
}
[data-testid="modal-footer"]{
      padding-top : 0px;
  }
  @media screen and (min-width:230px) and (max-width:767px){
    [data-testid="modal-header"]{
      padding-right : 40px;
    }
  }
  
`;

const ButtonGroup = styled.div`
display: flex;
margin-top: 25px;
margin-bottom: 2px;
column-gap: 10px;
height:44px;
span {
  margin-left:15px !important;
  margin-right:15px !important;
} 
@media screen and (max-width:830px) {
  position: absolute;
  bottom: 6rem;
  width: 95%;
  padding: 0px;
  margin-left: 0;
  flex-direction: column;
  row-gap: 12px;
  span {
    margin:0px !important;
  }
}
.customerButton{
  padding: 0 !important;
}
`;
export default RemoveModalByod